import { dmApi } from "../../../app/dmApi";
import {
  getAuthorizationHeader,
  handleQueryError,
  handleQueryErrorAndSuccess,
} from "../../../helpers/RtkQueryUtils";
import { serialize } from "../../../helpers/Utils";

export const mixingCartApi = dmApi.injectEndpoints({
  endpoints: (build) => ({
    getMixingCartList: build.query({
      query: (data) => {
        const paramData = serialize(data);
        return {
          url: `/mixing-cart-list?${paramData}`,
          method: "GET",
          headers: getAuthorizationHeader(),
        };
      },
      providesTags: ["mixingCartList"],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleQueryError(queryFulfilled);
      },
    }),

    createMixingCart: build.mutation({
      query: (requestBody) => ({
        url: `/mixing-cart/create`,
        method: "POST",
        headers: getAuthorizationHeader(),
        body: requestBody,
      }),
      invalidatesTags: ["mixingCartList", "allMixingCart"],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Mixing Cart");
      },
    }),

    getAllMixingCart: build.query({
      query: (data) => {
        const paramData = serialize(data);
        return {
          url: `/get-all-mixing-cart?${paramData}`,
          method: "GET",
          headers: getAuthorizationHeader(),
        };
      },
      providesTags: ["allMixingCart"],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleQueryError(queryFulfilled);
      },
    }),

    updateMixingCart: build.mutation({
      query: ({ id, requestBody }) => ({
        url: `/mixing-cart/update/${id}`,
        method: "PUT",
        headers: getAuthorizationHeader(),
        body: requestBody,
      }),
      invalidatesTags: ["mixingCartList" , "allMixingCart"],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Mixing Cart");
      },
    }),

    deleteMixingCart: build.mutation({
      query: (id) => ({
        url: `/mixing-cart/delete/${id}`,
        method: "DELETE",
        headers: getAuthorizationHeader(),
      }),
      invalidatesTags: ["mixingCartList", "allMixingCart"],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleQueryErrorAndSuccess(queryFulfilled, "Deleted", "Mixing Cart");
      },
    }),
  }),
});

export const {
  useGetMixingCartListQuery,
  useGetAllMixingCartQuery,
  useCreateMixingCartMutation,
  useUpdateMixingCartMutation,
  useDeleteMixingCartMutation,
} = mixingCartApi;
